import pluralize from "pluralize";
import type { FunctionComponentWithRef } from "react";

import CommentIcon from "./comment-button-icon.svg";
import { Container, StyledButton } from "./styles";

type Props = {
  className?: string;
  commentCount: number;
  onClick?: () => void;
};

export const ArticleCommentsBanner: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  commentCount,
  onClick,
  ref: forwardReference,
}) => (
  <Container className={className} ref={forwardReference}>
    <StyledButton onClick={onClick}>
      <span>
        {pluralize("Comment", commentCount)}{" "}
        {(commentCount ?? 0) > 0 && <strong>({commentCount})</strong>}
      </span>
      <CommentIcon />
    </StyledButton>
  </Container>
);
ArticleCommentsBanner.displayName = "ArticleCommentsBanner";
